import { FC } from "react";
import VariantItem from "~/components/Items/VariantItem";
import styles from "./ImageSelect.module.scss";
import classNames from "classnames";
import Image from "next/image";

interface ImageSelectProps {
  title?: string;
  options?: {
    label: string;
    value_index: number;
    url?: string;
    disabled?: boolean;
  }[];
  value?: number;
  onChange?: (value: {
    label: string;
    value_index: number;
    url?: string;
    disabled?: boolean;
  }) => void;
}

const ImageSelect: FC<ImageSelectProps> = ({
  title,
  options,
  value,
  onChange,
}) => {
  const optionsSelected = options?.find((op) => op.value_index === value);
  return (
    <VariantItem title={title} value={optionsSelected?.label}>
      <div className={classNames("flex gap-3 flex-wrap", styles.single_select)}>
        {options?.map((op) => (
          <div
            key={op.value_index}
            className={classNames(styles.select_item, {
              [styles.selected]: op.value_index === value,
              [styles.disabled]: op.disabled,
            })}
            onClick={op.disabled ? undefined : () => onChange?.(op)}
          >
            <img
              src={op.url ?? ""}
              alt={op.label}
             />
          </div>
        ))}
      </div>
    </VariantItem>
  );
};

export default ImageSelect;
